<script setup>
  import {
    ref
  } from 'vue'

  import { useI18n } from '@shared/i18n.js'

  const { vt } = useI18n('properties.index.js')

  const selected = ref(window.app.page.search_key.features || '')

  const filterFeatures = window.app.page.filter_features

  const submit = () => {
    const url = new URL(window.location.href)
    url.searchParams.delete('features')
    url.searchParams.append('features', selected.value)
    window.location.href = url.toString()
  }
</script>

<template>
  <div class="sort_item">
    <label class="select_type_a">
      <select v-model="selected" class="search-price-to for-sale" @change="submit">
        <option value="">{{ vt('features') }}</option>
        <option v-for="feature in filterFeatures" :key="`feature-#{feature.key}`" :value="feature.key">{{ feature.label }}</option>
      </select>
    </label>
  </div>
</template>
